module.exports = __webpack_public_path__ + "static/image4-e043aabf841daacaeee81feec1de7b63.jpg";